import PropTypes from 'prop-types'
import React from 'react'
import { Breadcrumb as BsBreadcrumb, Col, Row } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'

function Breadcrumbs(props) {
  const history = useHistory()

  const format = (crumb, i, active) => {
    const [title, href] = crumb
    const navigate = event => {
      event.preventDefault()
      if (!active) {
        history.push(href)
      }
    }

    return (
      <BsBreadcrumb.Item
        key={i}
        href={href}
        onClick={navigate}
        active={active}
        className={active ? 'font-weight-bold' : 'font-weight-bold'}
      >
        {title.toUpperCase()}
      </BsBreadcrumb.Item>
    )
  }

  return (
    <Row>
      <Col>
        <BsBreadcrumb className="mb-0">
          {props.crumbs.map((crumb, i) =>
            format(crumb, i, i === props.crumbs.length - 1),
          )}
        </BsBreadcrumb>
      </Col>
    </Row>
  )
}

Breadcrumbs.propTypes = {
  crumbs: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
}

export default Breadcrumbs
